import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import EventToAsyncDecorator from '../../../plugins/eventToAsyncDecorator'
import LocalizationPaginationRequest from '../../../RunPay/Admin/IServices/Models/LocalizationPaginationRequest';
import SaveVacancyRequest from '../../../RunPay/Admin/IServices/Models/UserMobile/SaveVacancyRequest';
import WsResponseModel from '../../../SchemaBuilderServer/Models/WsResponseModel';
import PaginationResponse from '../../../Common/ResponseModels/PaginationResponse';
import VacancyItemResponse from '../../../RunPay/Admin/IServices/Models/UserMobile/VacancyItemResponse';

export default class VacancyService {
	webApiService: WebApiService;
	DeleteEvent = new Events<WsResponseModel<Boolean>>();
	GetListEvent = new Events<WsResponseModel<PaginationResponse<VacancyItemResponse>>>();
	SaveEvent = new Events<WsResponseModel<number>>();
	constructor(webApiService: WebApiService) {
		const self = this;
		this.webApiService = webApiService;
		webApiService.on('VacancyService', 'Delete', (res: WsResponseModel<Boolean>) => {
			self.DeleteEvent.trigger(res);
		});
		webApiService.on('VacancyService', 'GetList', (res: WsResponseModel<PaginationResponse<VacancyItemResponse>>) => {
			self.GetListEvent.trigger(res);
		});
		webApiService.on('VacancyService', 'Save', (res: WsResponseModel<number>) => {
			self.SaveEvent.trigger(res);
		});
	}
	Delete(id: number = 0) { 	
        this.webApiService.send('VacancyService', 'Delete' , id);
    }
	GetList(request: LocalizationPaginationRequest = null) { 	
        this.webApiService.send('VacancyService', 'GetList' , request);
    }
	Save(request: SaveVacancyRequest = null) { 	
        this.webApiService.send('VacancyService', 'Save' , request);
    }
	 // async methods
	async deleteAsync(id: number = 0): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.Delete.bind(this), this.DeleteEvent)(id);
	}
	async getListAsync(request: LocalizationPaginationRequest = null): Promise<PaginationResponse<VacancyItemResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetList.bind(this), this.GetListEvent)(request);
	}
	async saveAsync(request: SaveVacancyRequest = null): Promise<number> {
		return EventToAsyncDecorator.getInstance().bind(this.Save.bind(this), this.SaveEvent)(request);
	}
}


// WEBPACK FOOTER //
// ./scripts/dataSource/api/RunPay/Admin/Services/VacancyService.ts